import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import constants from "../../assets/constants";
import * as PatientSessionActions from "../../state/redux/patientSession";
import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import NsightPartnerAgenda from "../widgets/nsight/nsightPartnerAgenda";
import NsightPatientSymptoms from "../widgets/nsight/nsightPatientSymptoms";
import PatientConditions from "../widgets/patientConditions";
import PatientGoals from "../widgets/patientGoals";
import PatientJournal from "../widgets/patientJournal";
import PatientMedications from "../widgets/patientMedications";
import PatientMotivations from "../widgets/patientMotivations";

const NsightPartnerPortal = props => {
  const { patientODM, loadPatientODMRequest } = props;

  useEffect(() => {
    if (patientODM == null) {
      loadPatientODMRequest(constants.demoUserId.userOne);
    }
  }, [patientODM, loadPatientODMRequest]);

  return (
    <Portal>
      <PortalAppBar title="NSIGHT" />
      <PortalGridContent>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <NsightPartnerAgenda />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <NsightPatientSymptoms patientChart={props.patientChart} />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <PatientGoals />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <PatientJournal />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <PatientMotivations />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <PatientMedications />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <PatientConditions />
        </Grid>

        {/* */}

        <Grid item xs={12}></Grid>
      </PortalGridContent>
    </Portal>
  );
};

const mapStateToProps = state => ({
  partnerODM: state.partnerSession.partnerODM,
  partnerAssessments: state.partnerSession.partnerAssessments,
  partnerPatients: state.partnerSession.partnerPatients,
  userODM: state.userSession.userODM,
});

const mapDispatchToProps = {
  loadPatientODMRequest: PatientSessionActions.loadPatientODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NsightPartnerPortal));
